/** Bottom-sheet detents on phones: small (peek), medium and large. */
export type Detent = "peek" | "medium" | "large";

const ORDER: Detent[] = ["peek", "medium", "large"];

/** Drag distance (px) below which a pointer gesture counts as a tap. */
export const DRAG_THRESHOLD = 24;

/** Tap or Enter/Space: peek -> medium -> large -> peek. */
export function cycle(d: Detent): Detent {
  return ORDER[(ORDER.indexOf(d) + 1) % ORDER.length] as Detent;
}

function step(d: Detent, by: 1 | -1): Detent {
  const i = Math.min(ORDER.length - 1, Math.max(0, ORDER.indexOf(d) + by));
  return ORDER[i] as Detent;
}

/** ArrowUp grows, ArrowDown shrinks. Null for any other key. */
export function onKey(d: Detent, key: string): Detent | null {
  if (key === "ArrowUp") return step(d, 1);
  if (key === "ArrowDown") return step(d, -1);
  return null;
}

/** `dy` is the pointer travel (negative = up). Null when it was too small to be a drag. */
export function afterDrag(d: Detent, dy: number): Detent | null {
  if (Math.abs(dy) < DRAG_THRESHOLD) return null;
  return step(d, dy < 0 ? 1 : -1);
}

export function detentLabel(d: Detent): string {
  const size = d === "peek" ? "small" : d === "medium" ? "medium" : "large";
  return `Resize panel. Currently ${size}.`;
}
